module.exports = __webpack_public_path__ + "img/banner-contacts.1cbb6f9c.png";